module.exports = __webpack_public_path__ + "static/media/1.af79b938.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row1/1.wav
// module id = 29
// module chunks = 0